module.exports = __webpack_public_path__ + "static/resume-a139994466e4a8d092537de637e9f345.png";